import React, { useMemo } from "react";
import { SensorDataSessionMarkerDot } from "@shared/models";

const PLOTTED_DOT_COLORS: Record<string, string> = {
  0: "#000000",
  1: "#33FFFF",
  2: "#0000FF",
  3: "#FFFF31",
  4: "#99FF31",
  5: "#9933FF",
  6: "#999900",
  7: "#FF0000",
};

const CustomDot = (props: any) => {
  const { cx, cy, dataKey, payload, value } = props;

  const plottedDotColor = useMemo(() => {
    return PLOTTED_DOT_COLORS[payload.tuning] || undefined;
  }, [payload]);

  const savedDotColor = useMemo(() => {
    const savedDot = payload.dots.find(
      (d: SensorDataSessionMarkerDot) =>
        (d.session_file_id === Number(dataKey) || d.session_station === String(dataKey)) &&
        Number(value) === Number(d.value),
    );

    return savedDot?.marker?.color;
  }, [payload.dots, dataKey, value]);

  const dotColor = useMemo(() => {
    return plottedDotColor || savedDotColor || undefined;
  }, [plottedDotColor, savedDotColor]);

  return <circle cx={cx} cy={cy} r={dotColor ? 1 : 0} stroke={dotColor} strokeWidth={1.5} fill={dotColor} />;
};

export default CustomDot;
